import { render, staticRenderFns } from "./FrontJacketForm.vue?vue&type=template&id=3870442b&scoped=true&"
import script from "./FrontJacketForm.vue?vue&type=script&lang=js&"
export * from "./FrontJacketForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3870442b",
  null
  
)

export default component.exports